import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function Hero() {
  return <section className="relative bg-brand-navy min-h-[90vh] flex items-center pt-40 pb-16 overflow-hidden" data-id="element-111" data-mp="eiv5avzyr8kb">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10" data-id="element-112" data-mp="9igx9dyd3yma">
        <div className="absolute inset-0" style={{
        backgroundImage: 'radial-gradient(#C9A24B 1px, transparent 1px)',
        backgroundSize: '40px 40px'
      }} data-id="element-113" data-mp="4mrsmw7hjrj4"></div>
      </div>

      {/* Gradient Overlay */}
      <div className="absolute inset-0 bg-gradient-to-br from-brand-navy via-brand-navy/95 to-brand-navy/80" data-id="element-114" data-mp="sbb1pdyd08c9"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 w-full" data-id="element-115" data-mp="ncq0pcba9kmr">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-8 items-center" data-id="element-116" data-mp="3d1ihv20l0yjq">
          {/* Main Content */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          ease: 'easeOut'
        }} className="lg:col-span-6 text-white" data-id="element-117" data-mp="382p9fo05jxqf">
            <div className="inline-flex items-center space-x-2 bg-white/5 border border-white/10 rounded-full px-4 py-1.5 mb-6" data-id="element-118" data-mp="39a36gxl5v9lq">
              <span className="w-2 h-2 rounded-full bg-brand-gold animate-pulse" data-id="element-119" data-mp="30i19xae7qdgq"></span>
              <span className="text-sm font-medium tracking-wide text-brand-paper" data-id="element-120" data-mp="30g6m9obk478y">
                National Managed Care Provider
              </span>
            </div>

            <h1 className="text-5xl sm:text-6xl lg:text-7xl font-serif font-medium leading-[1.1] mb-6 text-white text-balance" data-id="element-121" data-mp="2qleq8oxmhsga">
              Smarter managed care for{' '}
              <span className="text-brand-gold italic" data-id="element-122" data-mp="2hix4eblvr1tt">
                workers' compensation.
              </span>
            </h1>

            <p className="text-lg sm:text-xl text-white/80 mb-10 max-w-xl leading-relaxed font-light" data-id="element-123" data-mp="2ljz22o05f5to">
              For over 14 years, Arissa Cost Solutions has been a trusted
              national partner to insurance carriers, TPAs and employers —
              driving better outcomes for injured workers and measurable savings
              for you.
            </p>

            <div className="flex flex-col sm:flex-row items-start sm:items-center space-y-4 sm:space-y-0 sm:space-x-6" data-id="element-124" data-mp="de6n8os9pxjq">
              <a href="#contact" className="bg-brand-gold text-brand-navy px-8 py-4 rounded font-semibold text-base hover:bg-white transition-colors shadow-[0_0_20px_rgba(201,162,75,0.3)] flex items-center w-full sm:w-auto justify-center" data-id="element-125" data-mp="1b0duy7jvc60b">
                Request a Consultation
                <ArrowRight className="w-5 h-5 ml-2" data-id="element-126" data-mp="x3h0zx8ge8f7" />
              </a>
              <a href="#services" className="text-white border border-white/30 px-8 py-4 rounded font-semibold text-base hover:bg-white/10 transition-colors w-full sm:w-auto text-center" data-id="element-127" data-mp="3lui6mj3rolho">
                Explore Services
              </a>
            </div>
          </motion.div>

          {/* Image & Floating Stats Card */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          x: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          x: 0
        }} transition={{
          duration: 0.8,
          delay: 0.2,
          ease: 'easeOut'
        }} className="lg:col-span-6 relative mt-10 lg:mt-0" data-id="element-128" data-mp="268y5vkhju34k">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl aspect-[4/3] lg:aspect-auto lg:h-[600px]" data-id="element-129" data-mp="2oye606pbntkg">
              <img src="https://images.unsplash.com/photo-1511895426328-dc8714191300?ixlib=rb-4.0.3&auto=format&fit=crop&w=2400&q=90" alt="Family embracing, representing the human side of workers compensation" className="w-full h-full object-cover" data-id="element-130" data-mp="umheyeuskppx" />
              <div className="absolute inset-0 bg-brand-navy/20 mix-blend-multiply" data-id="element-131" data-mp="3vi6y0jozo8t5"></div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}